//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import mobileBg from '@/assets/mobile_bg.png'
// import man from '@/assets/man.png'
// import women from '@/assets/women.png'
import share from '@/components/Share'
import html2canvas from 'html2canvas'
import { getStorage, getEnv } from '@/js/utils'
import { newCallNative } from "@/js/callNativeMethods"

export default {
    name: 'helpToRepay',
    created() {
        const friendPayParams = getStorage('session', 'friendPayParams')
        this.friendPayParams = friendPayParams
        this.themeType = friendPayParams.themeType
        this.text = friendPayParams.wxCopywriting[0]
        this.repayAmount = friendPayParams.repayAmount
        this.realName = friendPayParams.realName
        this.period = friendPayParams.period

        this.isKoo = getEnv() === 'Koo';
    },
    mounted() {
        this.createTwoDimensional()
    },
    data() {
        return {
            // mobileBg,
            // man,
            // women,
            text: '',
            themeType: '',
            repayAmount: '',
            realName: '',
            qrcodeUrl: 'http://www.baidu.com',
            isBtnDisabled: false,
            isKoo: false
        }
    },
    components: { share },
    methods: {
        async changeText() {
            const wxCopywriting = this.friendPayParams.wxCopywriting
            const randomIdx = Math.floor(Math.random() * wxCopywriting.length)
            if (this.text === wxCopywriting[randomIdx]) {
                this.changeText()
            } else {
                this.text = wxCopywriting[randomIdx]
                await this.createTwoDimensional()
            }
        },
        async createTwoDimensional() {
            const { twoDimensionalUrl } = await this.doRequest(
                'createTwoDimensional',
                {
                    inputAmount: this.repayAmount,
                    orderNum: this.params.orderNo,
                    wxCopywriting: this.text,
                    multiPeriod: this.period
                }
            )
            this.qrcodeUrl = location.protocol + twoDimensionalUrl
            const splitArr = twoDimensionalUrl.split('qrcodeId=')
            this.twoDimensionalId = splitArr.length ? splitArr[1] : ''
        },
        async invite() {
            this.sendRecord('801')
            this.sensorsRecord("h5_clk", {
                tgt_event_id: "h5_paycash_syt_801",
                tgt_name: "h5-paycash-点击邀请好友帮还",
                url: location.href,
                page: "他人代偿页面",
            });

            this.isBtnDisabled = true
            document.body.scrollTop = 0
            const element = this.$refs.share.$el

            const canvas = await html2canvas(element, {
                windowWidth: element.scrollWidth,
                windowHeight: element.scrollHeight,
                allowTaint: true,
                useCORS: true,
            })
            const imgData = canvas.toDataURL()
            const splitArr = imgData.split('base64,')
            const base64Code = splitArr.length ? splitArr[1] : ''

            const { imgUrl } = await this.doRequest('shareUpload', {
                base64Code,
                fileExt: 'png',
                fileName: 'xxx',
                orderNum: this.params.orderNo,
                twoDimensionalId: this.twoDimensionalId
            })  

            if (this.isKoo) {
                window.resumeListener = () => {
                    this.isBtnDisabled = false
                };

                const params = {
                    method: 'wechatShare',
                    data: {
                        bText: false,
                        message: {
                            mediaObject: {
                                imageUrl: !/^https/.test(imgUrl)
                                    ? imgUrl.replace('http', 'https')
                                    : imgUrl,
                                text: ''
                            },
                            mediaTagName: "image"
                        },
                        scene: 0
                    },
                    version: '4.6.0'
                };

                newCallNative(params).then(res => {
                    const { data } = res;

                    this.sensorsRecord("h5_clk", {
                        tgt_event_id: "h5_paycash_koo_share_result",
                        tgt_name: "h5-paycash-koo分享结果",
                        url: location.href,
                        page: "他人代偿页面",
                        param4: JSON.stringify(data)
                    });

                    if (data) {
                        if (data.code != 1) {
                            this.showMsg(data.msg || '微信分享失败');
                        }
                    } else {
                        this.showMsg('微信分享失败');
                    }
                    this.isBtnDisabled = false
                }, error => {
                    this.showMsg(error);
                    this.isBtnDisabled = false
                });
            } else {
                PPDWebUI.SocialService.share(
                    {
                        messageStyle: 2,
                        shareImageUrl: !/^https/.test(imgUrl)
                            ? imgUrl.replace('http', 'https')
                            : imgUrl,
                        platforms: [4]
                    },
                    () => {
                        this.isBtnDisabled = false
                    },
                    error => {
                        this.isBtnDisabled = false
                    }
                )

                PPDWebUI.ListenerService.pauseListener(() => {
                    this.isBtnDisabled = false
                })
            }
        },
        showMsg(message) {
            this.$vux.toast.show({
                type: "text",
                text: message,
                width: "50%",
            });
        }
    }
}
